var map = {
	"./boule.svg": "4c8c",
	"./carton.svg": "09e2",
	"./escalier_marche_0.svg": "ae96",
	"./escalier_marche_1.svg": "daf8",
	"./escalier_marche_2.svg": "ee52",
	"./escalier_marche_3.svg": "75c1",
	"./machine.svg": "e987",
	"./tapis_roulant.svg": "91d5",
	"./tuyau_1.svg": "cc03",
	"./tuyau_2.svg": "6964",
	"./tuyau_3.svg": "d7f1",
	"./tuyau_4.svg": "0c33",
	"./tuyau_5.svg": "3156",
	"./tuyau_6.svg": "e5ab",
	"./tuyau_7.svg": "49ef",
	"./tuyau_a.svg": "732c",
	"./tuyau_a_2.svg": "e7e0",
	"./tuyau_e.svg": "0568",
	"./tuyau_i.svg": "1ad7",
	"./tuyau_j.svg": "b88b",
	"./tuyau_l.svg": "d1be",
	"./tuyau_o.svg": "2069",
	"./tuyau_u.svg": "7905"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1bed";